/**
 * @generated SignedSource<<5931ce84e027c0e796876aaf9c9cf129>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Page_recommendationsUsername_page$data = {
  readonly displayUsername: string;
  readonly firstName: string | null;
  readonly id: string;
  readonly lastName: string | null;
  readonly receivedTestimonials: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly recommend: boolean;
      };
    }>;
  };
  readonly recommendationRequests: {
    readonly count: number;
  };
  readonly visitorCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileLayout_userProfile" | "RequestedRecommendations_userProfile" | "UserReviews_userProfile">;
  readonly " $fragmentType": "Page_recommendationsUsername_page";
};
export type Page_recommendationsUsername_page$key = {
  readonly " $data"?: Page_recommendationsUsername_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"Page_recommendationsUsername_page">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Page_recommendationsUsername_page",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUsername",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReceivedTestimonialConnection",
      "kind": "LinkedField",
      "name": "receivedTestimonials",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReceivedTestimonialEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Testimonial",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recommend",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecommendationRequestConnection",
      "kind": "LinkedField",
      "name": "recommendationRequests",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileLayout_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RequestedRecommendations_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserReviews_userProfile"
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};
})();

(node as any).hash = "cdd884da4660df5679ef17cd8dac216f";

export default node;
